import { render, staticRenderFns } from "./showAllFeaturedSponsorsEdition.vue?vue&type=template&id=0ab87682"
import script from "./showAllFeaturedSponsorsEdition.vue?vue&type=script&lang=js"
export * from "./showAllFeaturedSponsorsEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports